import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { createValueAccessorProvider } from 'app/shared/utils/createValueAccessorProvider';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
  providers: [createValueAccessorProvider(PasswordInputComponent)]
})
export class PasswordInputComponent implements ControlValueAccessor {
  public showPassword: boolean = false
  public value: string = ''

  @Input() public disabled: boolean = false
  @Input() public placeholder: string = ''
  @Input() public autocomplete: string = 'off'
  @Input() public ngClass: NgClass['klass']
  @Input() public required: boolean = false

  @Output() public changeValue: EventEmitter<string> = new EventEmitter<string>()

  public onChange: (_: any) => void = () => { }
  public onTouched: () => void = () => { }

  public onInput(event: Event): void {
    const element = event.target as HTMLInputElement

    const value = element.value

    this.value = value

    this.onChange(value)

    this.changeValue.emit(value)
  }

  public togglePasswordVisibility() {
    this.showPassword = !this.showPassword
  }

  public writeValue(value: any): void {
    this.value = value ?? ''
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
  }
}
